import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import {ListScreen} from '../components';
import {
    fetchAiChatbotThreads,
    cleanAiChatbotThreads,
    setUser,
    changeUserSetting,
    deleteAiChatbotThread,
    deleteAiChatbotThreads,
} from '../actions';
import {
    __,
    formatAmount,
    formatDate,
    getCurrency, getCurrencyPrice, request,
} from '../functions';
import '../assets/styles/ai-chatbot-threads.css';
import DeleteIcon from "@mui/icons-material/Delete";
import ViewIcon from '@mui/icons-material/Folder';
import BlockIcon from '@mui/icons-material/Block';
import _ from 'lodash';

class AiChatbotThreadsScreen extends ListScreen {
    title = __('AI chatbot - konverzácie');

    state = { ...ListScreen.state, ...{
        blocked: {},
        lightbox: {
            unblock: false,
            block: false,
            delete: false,
            multidelete: false,
        },
    }};

    afterFetchList() {
        const { items } = this.props;

        this.setState({ blocked: _.reduce(items.blocked, (result, ip) => {
            return { ...result, [ip]: ip };
        }, {}) });
    }

    isValidPermission() {
        return this.hasPermission('aiaddons');
    }

    getTableName() {
        return 'ai-chatbot-threads';
    }

    getMultiselect() {
        return [
            {
                confirm: (ids, callback, callbackLoading) => this.showLightbox('multidelete', {
                    ids,
                    callback,
                    callbackLoading,
                }),
                icon: <DeleteIcon />,
                text: __('Zmazať'),
            },
        ];
    }

    getColumns() {
        return [
            <div>{__('ID')}</div>,
            <div>{__('Email')}</div>,
            <div>{__('Stav')}</div>,
            <div>{__('IP')}</div>,
            <div>{__('Počet správ')}</div>,
            <div>{__('Cena')}</div>,
            <div>{__('Vytvorené')}</div>,
            <div></div>,
        ];
    }

    getCells(item) {
        const { blocked } = this.state;

        const ip = _.has(item.data, 'ip') ? item.data.ip : '';
        const is_blocked = _.has(blocked, ip);

        let status = <span style={{ color: '#459350' }}>{__('Ukončené')}</span>;

        if (item.status === 'newly') {
            status = <span style={{ color: '#ff9931' }}>{__('Prebieha')}</span>;
        }

        return [
            <div>{item.id}</div>,
            <div>{_.has(item.data, 'email') ? item.data.email : ''}</div>,
            <div>{status}</div>,
            <div>{ip}</div>,
            <div>{item.messages}</div>,
            <div>{formatAmount(getCurrencyPrice(item.price), getCurrency(), 8)}</div>,
            <div>{formatDate(item.created, 'dd.mm.yyyy hh:ii')}</div>,
            <div>
                {this.renderTableButton(
                    item.id,
                    __('Zobraziť'),
                    <ViewIcon />,
                    (callbackLoading, callback) => this.redirect(`/ai-chatbot/messages/${item.id}`),
                    {}
                )}
                {is_blocked ? this.renderTableButton(
                    item.id,
                    __('Odblokovať IP'),
                    <BlockIcon color="error" />,
                    (callbackLoading, callback) => this.confirmUnblock(item.id, ip, callbackLoading, callback),
                    { disabled: ip === '' }
                ) : this.renderTableButton(
                    item.id,
                    __('Zablokovať IP'),
                    <BlockIcon />,
                    (callbackLoading, callback) => this.confirmBlock(item.id, ip, callbackLoading, callback),
                    { disabled: ip === '' }
                )}
                {this.renderTableButton(
                    item.id,
                    __('Zmazať'),
                    <DeleteIcon />,
                    (callbackLoading, callback) => this.confirmDelete(item.id, callbackLoading, callback),
                )}
            </div>,
        ];
    }

    getTags() {
        return [
            {
                name: __('Nastavenia'),
                onClick: () => this.redirect('/ai-addons/view/chat'),
            },
            {
                name: __('Otázky a odpovede'),
                onClick: () => this.redirect('/ai-chatbot/questions'),
            },
        ];
    }

    getEmptyText() {
        return __('Zatiaľ nemáte žiadne konverzácie');
    }

    confirmDelete(id, callbackLoading, callback) {
        this.showLightbox('delete', { id, callbackLoading, callback });
    }

    confirmBlock(id, ip, callbackLoading, callback) {
        this.showLightbox('block', { id, ip, callbackLoading, callback });
    }

    confirmUnblock(id, ip, callbackLoading, callback) {
        this.showLightbox('unblock', { id, ip, callbackLoading, callback });
    }

    async block() {
        const { lightbox, blocked } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('IP adresu nie je možné zablokovať na DEMO účte'))
            this.closeLightbox('block');
            return;
        }

        // Zavolame loading
        lightbox.block.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('block');

        await request(`/ai-chatbot-threads/block/${lightbox.block.id}`).then(response => {
            const { status } = response.data;

            if (status === 'error') {
                this.showSnackbar('error', __('Nepodarilo sa zablokovať IP adresu'));
                return;
            }

            this.setState({ blocked: { ...blocked, [lightbox.block.ip]: lightbox.block.ip } });
        });

        // Zavolame callback
        lightbox.block.callback();
    }

    async unblock() {
        let { lightbox, blocked } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('IP adresu nie je možné odblokovať na DEMO účte'))
            this.closeLightbox('unblock');
            return;
        }

        // Zavolame loading
        lightbox.unblock.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('unblock');

        await request(`/ai-chatbot-threads/unblock/${lightbox.unblock.id}`).then(response => {
            const { status } = response.data;

            if (status === 'error') {
                this.showSnackbar('error', __('Nepodarilo sa odblokovať IP adresu'));
                return;
            }

            blocked = _.omit(blocked, [lightbox.unblock.ip]);

            this.setState({ blocked });
        });

        // Zavolame callback
        lightbox.unblock.callback();
    }

    async delete() {
        const { deleteAiChatbotThread, items } = this.props;
        const { lightbox } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('Konverzáciu nie je možné zmazať na DEMO účte'))
            this.closeLightbox('delete');
            return;
        }

        // Zavolame loading
        lightbox.delete.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('delete');

        // Zmazeme
        await deleteAiChatbotThread(this, lightbox.delete.id);

        // Zavolame callback
        lightbox.delete.callback();

        // Znovu nacitame zoznam od prvej stranky
        this.fetchList(1, 0, items.filtered);
    }

    async multiDelete() {
        const { deleteAiChatbotThreads, items } = this.props;
        const { lightbox } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('Konverzácie nie je možné zmazať na DEMO účte'))
            this.closeLightbox('delete');
            return;
        }

        // Zavrieme lightbox
        this.closeLightbox('multidelete');

        // Zobrazime loading
        lightbox.multidelete.callbackLoading();

        await deleteAiChatbotThreads(this, lightbox.multidelete.ids, items.filtered);

        // Zavolame callback
        lightbox.multidelete.callback();

        // Znovu nacitame zoznam od prvej stranky
        this.fetchList(1, 0, items.filtered);
    }

    renderScreen() {
        return (
            <div>
                {this.renderLightbox(
                    'delete',
                    __('Naozaj chcete zmazať túto konverzáciu?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.delete()
                )}
                {this.renderLightbox(
                    'multidelete',
                    __('Naozaj chcete zmazať označené konverzácie?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.multiDelete()
                )}
                {this.renderLightbox(
                    'block',
                    __('Naozaj chcete zablokovať túto IP adresu?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.block()
                )}
                {this.renderLightbox(
                    'unblock',
                    __('Naozaj chcete odblokovať túto IP adresu?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.unblock()
                )}
                {this.renderSnackbar()}
            </div>
        );
    }
}

const stateToProps = ({ ai_chatbot_threads, user }) => ({ items: ai_chatbot_threads, user });

export default withCookies(connect(stateToProps, {
    fetch: fetchAiChatbotThreads,
    clean: cleanAiChatbotThreads,
    setUser,
    changeUserSetting,
    deleteAiChatbotThread,
    deleteAiChatbotThreads,
})(AiChatbotThreadsScreen));
